import TABS from '../../models/tabs.js';
import _ from 'lodash';

class navBarService {
  constructor() {
    this.name = 'navBarService';
    this.tabs = TABS;
  }

  setActiveTab(stateName) {
    this.deactivateTabs();
    let tab = _.find(this.tabs, {
      'stateName': stateName
    });
    tab.active = true;
  }

  deactivateTabs() {
    this.tabs.forEach((tab) => {
      tab.active = false;
    });
  }
}

export default navBarService;


// WEBPACK FOOTER //
// ./app/common/navBarService/navBarService.service.js